export default __webpack_public_path__ + "static/pob3d-navbar-brand-1a4fff3c66b1d36f544f52dae3c95e26.png";